export const BASE_URL = process.env.REACT_APP_API_URL;
export const REGISTER_API = BASE_URL + "/auth/register";
export const LOGIN_API = BASE_URL + "/auth/login";
export const WATERLEVEL_API = process.env.REACT_APP_WATERLEVEL_API_URL;
